import * as Sentry from '@sentry/react';
import React from 'react';
import ReactDOM from 'react-dom/client';

import App from 'App';
import TGApi from 'lib/webapp-api';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';
import { SENTRY_DSN, SENTRY_ENV, SENTRY_RELEASE, SENTRY_TRACING } from 'lib/constants';

Sentry.init({
  enabled: Boolean(Number(SENTRY_TRACING)),
  dsn: SENTRY_DSN,
  environment: SENTRY_ENV,
  release: SENTRY_RELEASE,
  integrations: [
    Sentry.browserProfilingIntegration(),
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.httpClientIntegration(),
    Sentry.sessionTimingIntegration(),
    Sentry.feedbackIntegration({
      triggerLabel: 'Сообщить об ошибке',
      namePlaceholder: 'Ваше имя',
      submitButtonLabel: 'Отправить',
      cancelButtonLabel: 'Отмена',
      isRequiredLabel: '(Обязательно)',
      formTitle: 'Сообщить об ошибке',
      successMessageText: 'Отчет об ошибке отправлен',
      addScreenshotButtonLabel: 'Добавить скриншот',
      removeScreenshotButtonLabel: 'Удалить скриншот',
      confirmButtonLabel: 'Принять',
      nameLabel: 'Имя',
      messageLabel: 'Описание',
      messagePlaceholder: 'Расскажите о неисправности, которую Вы обнаружили',
      colorScheme: 'system',
      autoInject: false,
    }),
    Sentry.replayIntegration({
      maskAllInputs: false,
      maskAllText: false,
      mask: ['password'],
    }),
    Sentry.captureConsoleIntegration({ levels: ['error'] }),
  ],

  tracesSampleRate: 1.0,

  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

TGApi.ready();
